import { ICommonLandingBottomComp } from "../../pages/InsuranceCommonLanding/types";
import BannerCarousel from "../BannerCarousel/BannerCarousel";
import ExclusiveOffers from "../ExculsiveOffers/ExclusiveOffers";
import InsuranceStats from "../InsuranceStats/InsuranceStats";
import LandingFaq from "../LandingFaq/LandingFaq";
import OffersBenefitsSection from "../OffersBenefitsSection/OffersBenefitsSection";
import PaymentOfferBreakdown from "../PaymentOfferBreakdown/PaymentOfferBreakdown";
import PoweredBySection from "../PoweredBySection/PoweredBySection";
import SafenSecureTrav from "../SafenSecureTrav/SafenSecureTrav";
import TestimonialsSection from "../TestimonialsSection/TestimonialsSection";
import WhatsCovered from "../WhatsCovered/WhatsCovered";
import WhyBuySection from "../WhyBuySection/WhyBuySection";
import WhyBuyTravIns from "../WhyBuyTravIns/WhyBuyTravIns";

const CommonLandingBottomComp = ({
  desktopLayout,
  offers,
}: ICommonLandingBottomComp) => {
  const {
    faq,
    customNumbers,
    whyBuySection,
    TravelInsData,
    safeSecureTravel,
    whatsCovered,
    offersAndBenefits,
    poweredBy,
    marketingBannerSection,
    testimonialSection,
    paymentOfferBreakdown,
  } = desktopLayout?.pageInfo || {};
  return (
    <>
      {customNumbers && <InsuranceStats data={customNumbers} />}
      {paymentOfferBreakdown && (
        <PaymentOfferBreakdown data={paymentOfferBreakdown} />
      )}
      {offers && <ExclusiveOffers data={offers} />}
      {whyBuySection && <WhyBuySection whyBuySectionData={whyBuySection} />}
      {TravelInsData && (
        <WhyBuyTravIns
          title={TravelInsData.title}
          info={TravelInsData.info}
          data={TravelInsData.featureCard}
        />
      )}
      {safeSecureTravel && (
        <SafenSecureTrav
          data={safeSecureTravel.safeTravCrd}
          title={safeSecureTravel.title}
        />
      )}
      {whatsCovered && (
        <WhatsCovered
          data={whatsCovered.travCrd}
          title={whatsCovered.title}
          info={whatsCovered.info}
        />
      )}
      {offersAndBenefits && <OffersBenefitsSection data={offersAndBenefits} />}
      {poweredBy && <PoweredBySection data={poweredBy} />}
      {testimonialSection && <TestimonialsSection data={testimonialSection} />}
      {marketingBannerSection && (
        <BannerCarousel
          banners={marketingBannerSection}
          autoScrollInterval={3000}
        />
      )}
      {faq && (
        <LandingFaq
          customTitle={faq?.title}
          faq={faq?.faqList}
          customInfo={faq?.info}
          icon={faq?.icon}
          isCommonLanding={true}
        />
      )}
    </>
  );
};

export default CommonLandingBottomComp;
